import { render, staticRenderFns } from "./backproject1.vue?vue&type=template&id=68d38b2a&scoped=true&"
import script from "./backproject1.vue?vue&type=script&lang=js&"
export * from "./backproject1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d38b2a",
  null
  
)

export default component.exports